<script setup>
import { Link } from '@inertiajs/vue3'

defineProps({
	text: {
		type: String,
		default: '',
		required: true,
	},
	href: {
		type: String,
		default: '',
		required: true,
	},
	external: {
		type: Boolean,
		default: true,
	},
	target: {
		type: String,
		default: '',
		required: true,
	},
	underline: {
		type: Boolean,
		default: true,
		required: false,
	},
	hover: {
		type: Boolean,
		default: true,
		required: false,
	},
	pointer: {
		type: Boolean,
		default: true,
		required: false,
	},
})

const emit = defineEmits(['click'])

function onClick(event) {
	emit('click', event)
}
</script>

<template>
	<Link
		v-bind="$attrs"
		:href="href"
		:external="external"
		:target="target"
		@click.stop="onClick"
	>
		<span
			:class="[
				hover
					? 'duration-300 ease-out hover:decoration-idrive-hover hover:text-idrive-hover'
					: 'duration-300 ease-out',
				pointer ? 'hover:cursor-pointer' : '',
				underline ? 'inline underline underline-offset-2 ' : '',
			]"
		>
			{{ text }}
		</span>
	</Link>
</template>
